module.exports = __webpack_public_path__ + "static/media/S (195).43db4c5d.jpg";